<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 px-4 py-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "tableDetailsCreate" })'>{{$lang.actions.createTable}}</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-autocomplete
            v-if="!isLocalAdmin"
            class="min-w max-w mx-2 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            :loading="companyLoading"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeTables : allTables"
          :search="search"
          :loading="allTables.length === 0"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.categoryName }}</td>
            <td class="text-xs-left">{{ props.item.sequenceNumber }}</td>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.status }}</td>
            <td class="text-xs-left min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'tableDetails', params: { id: props.item.id } })">{{$lang.actions.edit}}</v-btn>
              <v-btn class="primary elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';
  import { baseUrl } from "../../assets/url";
  import * as fetch_data from "../../assets/fetch_data";

  export default {
    data() {
      return {
        err: '',
        search: '',
        show: false,
        language: this.$cookie.get('lang') || 'en',
        companies: [],
        selectedCompany: '',
        companyLoading: true,
        headers: [
          { text: this.$lang.header.tableCategory, value: 'categoryName', align: 'left' },
          { text: this.$lang.labels.sequenceNumber, value: 'sequenceNumber', align: 'left' },
          { text: this.$lang.header.tableName, value: 'name', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allTables: [],
        isLocalAdmin: true,
      };
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchTablesforCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeTables() {
        const tables = this.allTables;
        const activeTables = [];
        for (let i=0; tables.length > i; i++) {
          if (tables[i].status === 'active') {
            activeTables.push(tables[i]);
          }
        }
        return activeTables;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      changeStatus(table) {
        const action = table.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`table/${action}/${table.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(table, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchTablesforCompany(id) {
        this.show = true;
        this.allTables = [];
        this.activeTables = [];
        this.$http.post('table/getall', { companyId: id })
        .then((res) => {
          if (res.body.status === 'Success') {
            this.allTables = res.body.details.map(table => {
              table.name = table.name[this.language];
              table.createdOn = this.formatDate(table.createdOn);
              return table;
            });
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (this.isLocalAdmin) {
        this.fetchTablesforCompany();
        return;
      }

      this.init()
        .then(() => {
          const edit = this.$cookie.get('companyedit');
          if (edit) this.selectedCompany = edit;
        });
    },
  };
</script>



// WEBPACK FOOTER //
// Tables.vue?0e18c755